import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/apiClient';
import { ChatType } from './types';
import { getCurrentTimeGreeting } from 'src/utils/chatbot';
import { MANAGE_PROFILE_GET_USER_DETAILS } from 'src/constants/httpEndPoints';
import { PAULA_BOT_URL } from 'src/constants/env';
import { PaulaErrorMessage } from './constants';

export const sendMessage = createAsyncThunk<ChatType, { message: string; customerId: string }>(
  'chatbot/sendMessage',
  async ({ message, customerId }) => {
    const res = await apiClient.post(PAULA_BOT_URL, {
      query: message,
      customerId,
      chatHistory: [],
    });
    const responseMessage = (res.data?.answer || '') as string;
    const error = responseMessage.includes('ERROR') ? PaulaErrorMessage : undefined;

    return {
      message: responseMessage,
      loading: false,
      sender: 'bot',
      recievedAt: new Date().toISOString(),
      error,
    };
  },
);

export const getGreetingMessage = createAsyncThunk<ChatType, { email: string }>(
  'chatbot/getGreetingMessage',
  async (payload, { getState }) => {
    let firstName = '';
    try {
      const state = getState() as any;
      const userDetails = state.userDetails?.data;
      if (userDetails?.firstName) {
        firstName = userDetails?.firstName || '';
      }
      else {
        const response = await apiClient.post(MANAGE_PROFILE_GET_USER_DETAILS, payload);
        firstName = response.data.obj.firstName;
      }
    } catch (error) {
      console.error('Error accessing userDetails from Redux:', error);
    }

    const greetingMessage = `${getCurrentTimeGreeting()}${' **' + firstName + '**'
      }, <br/>Welcome to work, <br/>I am <span style='color:#7E3AF2; font-weight: 700;'>Paula</span>, your GTM assistant. <br/>Need a hand or have any questions? Just let me know, I'm here to help!`;
    return {
      message: greetingMessage,
      sender: 'bot',
      loading: false,
      recievedAt: new Date().toISOString(),
    };
  },
);
